// react
import React from 'react';

// mui
import { Box, Stack } from '@mui/material';

// components
import { Icons } from '@/components/atoms/Icon/icons';
import { AccountInfoProps } from '@/pwa/atoms/AccountInfo/AccountInfo';
import { NavDesktop } from '@/pwa/molecules/NavDrawer/NavDesktop';
import { NavMobile } from '@/pwa/molecules/NavDrawer/NavMobile';

export interface LinkItem {
  label: string;
  icon: Icons;
  to?: string;
  onClick?: () => void;
}

export interface NavDrawerProps {
  children: React.ReactNode;
  links: LinkItem[];
  accountInfoProps?: AccountInfoProps;
  activePath?: string;
}
/**
 * NavDrawer shows either NavDesktop or NavMobile based on mode prop.
 */
export const NavDrawer = ({
  children,
  links,
  accountInfoProps,
  activePath,
}: NavDrawerProps) => {
  return (
    <Stack
      direction={{ sm: 'column', md: 'row' }}
      spacing={0}
      sx={{
        height: '100%',
        maxWidth: '100vw',
        maxHeight: '100%',
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flexShrink: 0,
          overflowY: 'auto',
          minHeight: 0,
        }}
      >
        <NavDesktop
          links={links}
          accountInfoProps={accountInfoProps}
          activePath={activePath}
        />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          display: { xs: 'flex', md: 'none' },
          flexShrink: 0,
        }}
      >
        <NavMobile links={links} activePath={activePath} />
      </Box>
    </Stack>
  );
};

NavDrawer.displayName = 'NavDrawer';
export default NavDrawer;
